export const fetchWebNotifications = resp => {
  return {
    type: "FETCH_WEB_NOTIFICATIONS",
    payload: resp
  };
};

export const readNotification = resp => {
  return {
    type: "READ_NOTIFICATION",
    payload: resp
  };
};



// WEBPACK FOOTER //
// ./src/actions/actions/notifications.js